import type { AgendaDay, AgendaSection, CustomerConfig, FAQ, SlideDefinition, TeamMember } from "../types";

import { jlrConfig } from "./jlr/config";
import { jlrAgenda, jlrAgendaSections } from "./jlr/agenda";
import { jlrSlides } from "./jlr/slides";
import { jlrTeam } from "./jlr/team";
import { jlrFaqs } from "./jlr/faqs";

import { gitlabConfig } from "./gitlab/config";
import { gitlabAgenda, gitlabAgendaSections } from "./gitlab/agenda";
import { gitlabSlides } from "./gitlab/slides";
import { gitlabTeam } from "./gitlab/team";
import { gitlabFaqs } from "./gitlab/faqs";

import { redhatConfig } from "./redhat/config";
import { redhatAgenda, redhatAgendaSections } from "./redhat/agenda";
import { redhatSlides } from "./redhat/slides";
import { redhatTeam } from "./redhat/team";
import { redhatFaqs } from "./redhat/faqs";

import { automotiveVenturesConfig } from "./automotive-ventures/config";
import {
  automotiveVenturesAgenda,
  automotiveVenturesAgendaSections,
} from "./automotive-ventures/agenda";
import { automotiveVenturesSlides } from "./automotive-ventures/slides";
import { automotiveVenturesTeam } from "./automotive-ventures/team";
import { automotiveVenturesFaqs } from "./automotive-ventures/faqs";

import { bmwConfig } from "./bmw/config";
import { bmwAgenda, bmwAgendaSections } from "./bmw/agenda";
import { bmwSlides } from "./bmw/slides";
import { bmwTeam } from "./bmw/team";
import { bmwFaqs } from "./bmw/faqs";

export type CustomerData = {
  slides: SlideDefinition[];
  agenda: AgendaDay[];
  agendaSections: AgendaSection[];
  team: TeamMember[];
  faqs: FAQ[];
};

export const customers: Record<string, CustomerConfig> = {
  jlr: jlrConfig,
  gitlab: gitlabConfig,
  redhat: redhatConfig,
  "automotive-ventures": automotiveVenturesConfig,
  bmw: bmwConfig,
};

const customerData: Record<string, CustomerData> = {
  jlr: {
    slides: jlrSlides,
    agenda: jlrAgenda,
    agendaSections: jlrAgendaSections,
    team: jlrTeam,
    faqs: jlrFaqs,
  },
  gitlab: {
    slides: gitlabSlides,
    agenda: gitlabAgenda,
    agendaSections: gitlabAgendaSections,
    team: gitlabTeam,
    faqs: gitlabFaqs,
  },
  redhat: {
    slides: redhatSlides,
    agenda: redhatAgenda,
    agendaSections: redhatAgendaSections,
    team: redhatTeam,
    faqs: redhatFaqs,
  },
  "automotive-ventures": {
    slides: automotiveVenturesSlides,
    agenda: automotiveVenturesAgenda,
    agendaSections: automotiveVenturesAgendaSections,
    team: automotiveVenturesTeam,
    faqs: automotiveVenturesFaqs,
  },
  bmw: {
    slides: bmwSlides,
    agenda: bmwAgenda,
    agendaSections: bmwAgendaSections,
    team: bmwTeam,
    faqs: bmwFaqs,
  },
};

export function getCustomer(id: string): CustomerConfig | undefined {
  return customers[id];
}

export function getCustomerData(id: string): CustomerData | undefined {
  return customerData[id];
}
